import React from "react";

/**
 * PopupCard - reusable card for order popup
 * @param {string} imgSrc - image source
 * @param {string} alt - alt text for image
 * @param {string} name - display name
 * @param {string} href - link to order
 * @param {string} bgColor - background color for image
 * @param {string} boxShadow - box shadow for card
 * @param {string} imgGlow - filter for image glow
 */
export default function PopupCard({
  imgSrc,
  alt,
  name,
  href,
  bgColor,
  boxShadow,
  imgGlow,
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        borderRadius: "1.5rem",
        boxShadow: boxShadow || "0 2px 16px rgba(0,0,0,0.12)",
        padding: "1.5rem 2rem",
        textDecoration: "none",
        minWidth: "140px",
        transition: "transform 0.15s",
      }}
      onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
      onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <img
        src={imgSrc}
        alt={alt}
        style={{
          width: 72,
          height: 72,
          marginBottom: 12,
          borderRadius: "50%",
          background: bgColor,
          objectFit: "cover",
          transition: "box-shadow 0.2s, filter 0.2s",
        }}
      />
      <span
        style={{
          fontWeight: 800,
          color: "#222",
          fontSize: "1.15rem",
          marginTop: 4,
          letterSpacing: "0.01em",
          whiteSpace: "nowrap",
          textShadow: "0 2px 8px #fff, 0 1px 0 #fff",
        }}
      >
        {name}
      </span>
    </a>
  );
}
